const messages = {
    dashboard: {
        title: "Wholesaler Dashboard",
        extraTitle: "WHOLESALER DASHBOARD",
        description:
            "Welcome to your dashboard. Here you can view the figures and participating companies from your customer base.",
        overview: {
            title: "Overview of Participating Customers",
            description:
                "Companies that have registered with BRIDGESTONE PLUS and that we can assign to your companies via their customer number.",
            month: "New this month",
            year: "New this year",
            all: "Total",
        },
        credits: {
            title: "Points Credits {name}",
            description:
                "Reward points awarded to participating companies based on the sales figures you have uploaded. In this view, regular points are shown without promotions.",
            month: "Last month",
            year: "Current year",
            prev_year: "Total",
            allDealers: "All dealer points",
        },
        details: {
            title: "Participating Customers Details",
            description:
                'Below you will find the companies that have registered on BRIDGESTONE <span class="text-danger">PLUS</span> with a {name} customer number and have been assigned to you as responsible. Simply use the sorting functions to change the order or use the search field.',
        },
        lastImport:
            'Last import of sales figures: <br/> <span class="text-danger">{date}</span>',
        loadMore: "Load 20 more dealers",
        tyres: {
            title: "Tires",
            description: "Tires purchased by program participants",
        },
    },
};

export default {
    messages,
};
